import React from "react";
import Navbar from "../components/Home/Navbar";
import HeroSection from "../components/Home/HeroSection";
import BenefitsSection from "../components/Home/BenefitsSection";
import DividerSection from "../components/Home/DividerSection";
import Footer from "../components/Home/Footer";
import AITrendSection from "../components/Home/AITrendSection";
import HowItWorksSection from "../components/Home/HowItWorksSection";
import AdvantagesSection from "../components/Home/AdvantagesSection";
import AboutUsSection from "../components/Home/AboutUsSection";
import PricingPlans from "../components/Home/PricingPlans";
import DigitalCopyResult from "../components/Home/DigitalCopyResult";
import Contact from "../components/Home/Contact";

const App = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Navbar />
      <div className="pt-20">
        <section id="hero">
          <HeroSection />
        </section>
        <DividerSection />
        <section id="benefits">
          <BenefitsSection />
        </section>
        <AITrendSection />
        <DigitalCopyResult />
        <DividerSection />
        <section id="pricing">
          <PricingPlans />
        </section>
        <section id="how-it-works">
          <HowItWorksSection />
        </section>
        <DividerSection />
        <section id="about">
          <AboutUsSection />
        </section>
        <section id="advantages">
          <AdvantagesSection />
        </section>
                <section id="contact-us">
          <Contact />
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default App;
